import React, { useEffect } from "react";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
} from "@mui/material";
import { SubmitButton } from "../components/buttons";
import { mapStateToProps } from "../store/helpers/mapState";
import { mapDispatchToProps } from "../store/helpers/mapDispatch";
import { connect } from "react-redux";

const UserRole = (props) => {
  // const [checked, setChecked] = React.useState([]);
  const [checkedRole, setCheckedRole] = React.useState([]);
  const [searchUsers, setSearchUsers] = React.useState(null);
  const [searchRole, setSearchRole] = React.useState(null);
  const {
    users,
    setSelect,
    roles,
    onSelectRole,
    title,
    GetAllRoles,
  } = props;
  // let filterUsers = searchUsers ?? users;
  let filterRoles = searchRole ?? roles;

  // const checkedUser = (user) => {
  //   let temp = [...checked];
  //   if (!temp.includes(user)) {
  //     temp.push(user);
  //     setChecked(temp);
  //   }
  // };
  // const unCheckUser = (user) => {
  //   let array = [...checked];
  //   let index = array.indexOf(user);
  //   if (index !== -1) {
  //     array.splice(index, 1);
  //     setChecked(array);
  //   }
  // };
  // const onCheck = (user) => {
  //   if (!checked.includes(user)) {
  //     checkedUser(user);
  //   } else {
  //     unCheckUser(user);
  //   }
  // };
  // const onCheckAll = (user) => {
  //   if (checked !== users) {
  //     setChecked(user);
  //   } else {
  //     setChecked([]);
  //   }
  // };
  // ==========================role======================

  const checkedRoles = (role) => {
    let temp = [...checkedRole];
    if (!temp.includes(role)) {
      temp.push(role);
      setCheckedRole(temp);
    }
  };
  const unCheckRole = (role) => {
    let array = [...checkedRole];
    let index = array.indexOf(role);
    if (index !== -1) {
      array.splice(index, 1);
      setCheckedRole(array);
    }
  };
  const onCheckRole = (role) => {
    if (!checkedRole.includes(role)) {
      checkedRoles(role);
    } else {
      unCheckRole(role);
    }
  };
  const onCheckAllRole = (role) => {
    if (checkedRole !== role) {
      setCheckedRole(role);
    } else {
      setCheckedRole([]);
    }
  };
  const handleOnkeyUp = (e) => {
    let value = e.currentTarget.value.toLowerCase();
    let newArray = users?.filter(
      (item) => item?.UserInfo?.names.toLowerCase().indexOf(value) !== -1
    );
    setSearchUsers(newArray);
  };
  // const handleOnkeyUpRole = (e) => {
  //   let value = e.currentTarget.value.toLowerCase();
  //   let newArray = roles?.filter(
  //     (item) => item.value.toLowerCase().indexOf(value) !== -1
  //   );
  //   setSearchRole(newArray);
  // };

  useEffect(() => {
    GetAllRoles();
  }, [GetAllRoles]);

  return (
    <Card>
      <CardHeader title={title} titleTypographyProps={{ variant: "h6" }} />
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          onSelectRole(checkedRole);
          setSelect(false);
        }}
      >
        <CardContent>
          <div className="row ">
            <div className="col-md-10 justify-content-center">
              <Card variant={"outlined"}>
                <CardHeader
                  title={"ROLE"}
                  titleTypographyProps={{ variant: "subtitle1" }}
                  action={
                    <input
                      placeholder="Search here.."
                      className="form-control form-control-sm"
                      type="text"
                      onKeyUp={(e) => handleOnkeyUp(e)}
                    />
                  }
                />
                <CardContent>
                  <ul className="list-group p-3">
                    <li className="list-group-item">
                      <input
                        className="form-check-input me-1"
                        type="checkbox"
                        checked={checkedRole === roles}
                        onChange={(e) => {
                          onCheckAllRole(roles);
                        }}
                      />
                    </li>
                    {filterRoles?.map((role, index) => (
                      <li className="list-group-item">
                        <input
                          className="form-check-input me-1"
                          type="checkbox"
                          checked={checkedRole.includes(role)}
                          onChange={(e) => {
                            onCheckRole(role);
                          }}
                        />
                        {role?.name}
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            </div>
          </div>
        </CardContent>
        <CardActions className={"float-end"}>
          <SubmitButton name="ADD" />
        </CardActions>
      </form>
    </Card>
  );
};
// export default UserRole;
export default connect(mapStateToProps, mapDispatchToProps)(UserRole);
